"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.base64Encoder = exports.base64Decoder = void 0;
var base64Decoder_1 = require("./base64/base64Decoder");
Object.defineProperty(exports, "base64Decoder", { enumerable: true, get: function () { return base64Decoder_1.base64Decoder; } });
var base64Encoder_1 = require("./base64/base64Encoder");
Object.defineProperty(exports, "base64Encoder", { enumerable: true, get: function () { return base64Encoder_1.base64Encoder; } });
